import { Injectable } from '@angular/core';
import { MdlSnackbarService } from '@angular-mdl/core';

import { TranslateService } from '../../translate/translate.service';

@Injectable()
export class SnackbarService {

    displayMessage: any = '';
    constructor(
        private _mdlSnackbarService: MdlSnackbarService,
        private _translate: TranslateService
    ) {
    }

    showSnackbar(snackBarKey: any, success?: any) {
        this.displayMessage = this._translate.instant(snackBarKey);
        if (success) {
            document.body.classList.add('success-toast');
        } else {
            if (document.body.classList.contains('success-toast')) {
                document.body.classList.remove('success-toast')
            }
        }
        this.generateSnackbar(this.displayMessage);
    }

    generateSnackbar (snackBarMessage:any) {
        this._mdlSnackbarService.showSnackbar({
            message: snackBarMessage,
            timeout: 5000,
            closeAfterTimeout: true,
            action: {
                handler: () => {
                },
                text: 'OK'
            }
        });
    }
}